import React, { Component } from 'react';
import settingsEmail from './../../account-settings-email.js';

class AccountSettingsEmail extends Component {
	componentWillMount() {
		settingsEmail.setActive(true);
	}

	componentWillUnmount() {
		settingsEmail.setActive(false);
	}

	render() {
		return <div id="account-verify-email" />;
	}
}

export default AccountSettingsEmail;




// WEBPACK FOOTER //
// ./mobile-core/src/components/account/account-settings-email.js